import { createContext, useContext } from 'react';

export const DashboardPrintRenderContext = createContext(false);

export const useDashboardPrintRender = () => useContext(DashboardPrintRenderContext);
